import { Routes, Route } from "react-router-dom";
import "./App.css";
import AppRoutes from "./routes/routes";

function App() {
  return (
    <div className="app">
      <AppRoutes />
    </div>
  );
}

export default App;
